export enum Direction {
  left = -1,
  right = 1,
}

export interface RecaptchaResponse {
  success: boolean;
  challenge_ts: string;
  hostname: string;
  score: number;
}

export enum NavbarColor {
  brand = 'brand',
  light = 'light',
}
